import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./myworks.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./myworks.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/myworks.vue?vue&type=script&lang=js&
// module id = XmcQ
// module chunks = 0